import React from 'react';
import { Body, Modal } from '@icarros/ids-react';
import { ModalBody } from './style';

interface AnalyzingModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
}

export function Analyzing({ modalOpen, setModalOpen }: AnalyzingModalProps): JSX.Element {
  return (
    <Modal
      stateOpen={[modalOpen, setModalOpen]}
      body={
        <ModalBody>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Todo anúncio que entra em análise, precisa passar por uma verificação de informações
            antes de ser publicado. Realizamos essa ação, pois temos um compromisso com a segurança
            de nossos clientes.
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Se o seu anúncio está em análise, não se preocupe, entraremos em contato em até 2 dias
            úteis para finalizarmos a análise e publicarmos seu anúncio.
          </Body>
        </ModalBody>
      }
      title="por que o anúncio está em análise?"
      mainButtonText="entendi"
      mainButtonMethod={() => setModalOpen(false)}
    />
  );
}
